/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Whether the question belongs to the test world or the survey world. They score in incompatible ways, so a test must never draw a survey question.
 * @export
 * @enum {string}
 */

export const QuestionPurposeDto = {
    Test: 'TEST',
    Survey: 'SURVEY'
} as const;

export type QuestionPurposeDto = typeof QuestionPurposeDto[keyof typeof QuestionPurposeDto];



